const KEY_PREFIX = "mq_";
const KEY_NAME = /^[A-Za-z_][A-Za-z0-9_]*$/;
const STRING_REF = /^\$+[A-Za-z_][A-Za-z0-9_.]*$/;

function isPlainObject(value) {
  return (
    value !== null &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    !(value instanceof Date)
  );
}

function encodeString(value) {
  if (!STRING_REF.test(value)) return value;
  const dollars = value.match(/^\$+/)[0].length;
  const rest = value.slice(dollars);
  if (dollars === 1) return `mqs_${rest}`;
  return `mqs${dollars}_${rest}`;
}

export function encodeMongoOps(value) {
  if (typeof value === "string") return encodeString(value);
  if (Array.isArray(value)) return value.map(encodeMongoOps);
  if (!isPlainObject(value)) return value;
  const out = {};
  for (const [key, child] of Object.entries(value)) {
    const nextKey =
      key.startsWith("$") && KEY_NAME.test(key.slice(1))
        ? `${KEY_PREFIX}${key.slice(1)}`
        : key;
    out[nextKey] = encodeMongoOps(child);
  }
  return out;
}
